import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import AnalyticsPageUI from './AnalyticsPageUI.js'

class AnalyticsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      accountStats: null,
      width: null
    }

    this.myRef = null;
  }

  render() {
    return (
      <AnalyticsPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        accountStats={this.state.accountStats}
        setMyRef={this.setMyRef}
        width={this.state.width}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getStats(context)
    console.log("Hello", this.myRef)
    //this.getMessages(context)
  }

  setMyRef = (element) => {
    console.log("Hello", element)
    if (element) {
      this.myRef = element
    }

    // if condition is needed to avoid infinite loops
    // 100 is subtracted to account for the amount
    if(element && this.state.width !== element.offsetWidth - 100) {
      this.setState({
        width: element.offsetWidth - 100
      })
    }
  }

  getStats(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/stats`,
      cacheKey: CacheKeys.AccountStats(context.session.accountId),
      callback: this.getStatsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getStatsCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      accountStats: response.accountStats
    })
  }

  getMessages(context) {
    let arr = [
      'c_something',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_f_anl', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }
}

export default withRouter(AnalyticsPageSF)
